
import { requestWithToken } from '../../utilities/request';
import { convertCoordinatesToGeoJSON } from '../../utilities/geoJsonUtil';
const path = '/api/private/fields';

/**
 * エリア取得API
 * @param {string} fieldId 現場ID
 * @param {object} area エリア
 */
const fetchInOutFieldArea = (fieldId, area) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/${area.id}`),
  });
};

/**
 * エリア一覧取得API
 * @param {string} fieldId 現場ID
 */
const fetchInOutFieldAreas = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/list`),
  });
};

/**
 * エリア更新API
 * @param {string} fieldId 現場ID
 * @param {object} area エリア
 */
const editInOutFieldArea = (fieldId, area) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/${area.id}`),
    data: {
      name: area.name,
      latitude: area.latitude,
      longitude: area.longitude,
      radius: area.radius,
      polygon_coordinates: convertCoordinatesToGeoJSON(area.polygon_coordinates),
      use_location_info_flg: area.use_location_info_flg,
    },
  });
};

/**
 * エリア登録API
 * @param {string} fieldId 現場ID
 * @param {object} area エリア
 */
const createInOutFieldArea = (fieldId, area) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/check_in_out_field_areas`),
    data: {
      name: area.name,
      latitude: area.latitude,
      longitude: area.longitude,
      radius: area.radius,
      polygon_coordinates: convertCoordinatesToGeoJSON(area.polygon_coordinates),
      use_location_info_flg: area.use_location_info_flg
    }
  });
};

/**
 * エリア削除API
 * @param {string} fieldId 現場ID
 * @param {string} areaId エリア
 */
const deleteArea = (fieldId, areaId) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/${areaId}`),
  });
};

/**
 * QRコードダウンロードAPI
 * @param {string} fieldId 現場ID
 * @param {string} areaId エリア
 */
const downloadQRCode = (fieldId, areaId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/${areaId}/qr_code`),
  });
}

/**
 * エリア位置情報利用フラグ更新API
 * @param {string} fieldId 現場ID
 * @param {object} area エリア
 */
const editInOutFieldAreaLocationFlag = (fieldId, area) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_field_areas/${area.id}/location_info_flg_update`),
    data: {
      use_location_info_flg: area.use_location_info_flg
    }
  });
};

export const InOutFieldAreasApi = {
  fetchInOutFieldArea,
  fetchInOutFieldAreas,
  editInOutFieldArea,
  editInOutFieldAreaLocationFlag,
  createInOutFieldArea,
  deleteArea,
  downloadQRCode,
};



// WEBPACK FOOTER //
// ./src/services/InOutFieldAreas/InOutFieldAreasApi.js